import _classCallCheck from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/home/runner/work/iculture-vergelijker/iculture-vergelijker/node_modules/@babel/runtime/helpers/esm/inherits";
import * as React from "react";
import * as PropTypes from "prop-types";
import { SearchkitComponent, NestedFacetAccessor, renderComponent, RenderComponentPropType } from "../../../../../core";
import { Panel, ItemComponent } from "../../../../ui";

var defaults = require("lodash/defaults");

var map = require("lodash/map");

var identity = require("lodash/identity");

export var HierarchicalRefinementFilter =
/*#__PURE__*/
function (_SearchkitComponent) {
  _inherits(HierarchicalRefinementFilter, _SearchkitComponent);

  function HierarchicalRefinementFilter() {
    _classCallCheck(this, HierarchicalRefinementFilter);

    return _possibleConstructorReturn(this, _getPrototypeOf(HierarchicalRefinementFilter).apply(this, arguments));
  }

  _createClass(HierarchicalRefinementFilter, [{
    key: "defineBEMBlocks",
    value: function defineBEMBlocks() {
      var blockClass = this.props.mod || "sk-hierarchical-refinement";
      return {
        container: "".concat(blockClass, "-list"),
        option: "".concat(blockClass, "-option")
      };
    }
  }, {
    key: "defineAccessor",
    value: function defineAccessor() {
      var _this$props = this.props,
          field = _this$props.field,
          id = _this$props.id,
          title = _this$props.title,
          size = _this$props.size,
          orderKey = _this$props.orderKey,
          orderDirection = _this$props.orderDirection,
          startLevel = _this$props.startLevel;
      return new NestedFacetAccessor(id, {
        field: field,
        id: id,
        title: title,
        size: size,
        orderKey: orderKey,
        orderDirection: orderDirection,
        startLevel: startLevel
      });
    }
  }, {
    key: "addFilter",
    value: function addFilter(level, option) {
      this.accessor.state = this.accessor.state.toggleLevel(level, option.key);
      this.searchkit.performSearch();
    }
  }, {
    key: "renderOption",
    value: function renderOption(level, option) {
      var block = this.bemBlocks.option;
      var active = this.accessor.resultsState.contains(level, option.key);
      var _this$props2 = this.props,
          countFormatter = _this$props2.countFormatter,
          itemComponent = _this$props2.itemComponent;
      return React.createElement("div", {
        key: option.key
      }, renderComponent(itemComponent, {
        active: active,
        bemBlocks: this.bemBlocks,
        label: this.translate(option.key),
        itemKey: option.key,
        count: countFormatter(option.doc_count),
        showCount: true,
        onClick: this.addFilter.bind(this, level, option)
      }), active && this.renderOptions(level + 1));
    }
  }, {
    key: "renderOptions",
    value: function renderOptions(level) {
      var block = this.bemBlocks.container;
      return React.createElement("div", {
        className: block("hierarchical-options")
      }, map(this.accessor.getBuckets(level), this.renderOption.bind(this, level)));
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.accessor) return null;
      var block = this.bemBlocks.container;
      var _this$props3 = this.props,
          id = _this$props3.id,
          title = _this$props3.title,
          containerComponent = _this$props3.containerComponent;
      return renderComponent(containerComponent, {
        title: title,
        className: id ? "filter--".concat(id) : undefined,
        disabled: this.accessor.getBuckets(0).length == 0
      }, React.createElement("div", {
        className: block("root")
      }, this.renderOptions(0)));
    }
  }]);

  return HierarchicalRefinementFilter;
}(SearchkitComponent);
HierarchicalRefinementFilter.defaultProps = {
  countFormatter: identity,
  containerComponent: Panel,
  itemComponent: ItemComponent
};
HierarchicalRefinementFilter.propTypes = defaults({
  field: PropTypes.string.isRequired,
  id: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
  orderKey: PropTypes.string,
  orderDirection: PropTypes.oneOf(["asc", "desc"]),
  startLevel: PropTypes.number,
  countFormatter: PropTypes.func,
  containerComponent: RenderComponentPropType,
  itemComponent: RenderComponentPropType
}, SearchkitComponent.propTypes);